module.exports = __webpack_public_path__ + "img/paul-pogba.fc9a22a9.png";